import { NzTableSortOrder } from 'ng-zorro-antd/table';

export type SortDirection = Exclude<NzTableSortOrder, null>;

export interface SortCriterion {
  key: string;
  order: SortDirection;
}

export function applyColumnSort(
  current: SortCriterion[],
  key: string,
  order: NzTableSortOrder,
  shift: boolean
): SortCriterion[] {
  if (!order) {
    return shift ? current.filter(criterion => criterion.key !== key) : [];
  }

  if (!shift) {
    return [{ key, order: order as SortDirection }];
  }

  const next = current.filter(criterion => criterion.key !== key);
  next.push({ key, order: order as SortDirection });
  return next;
}

export function sortQueryParams(criteria: SortCriterion[]): { sort?: string[] } {
  if (!criteria.length) {
    return {};
  }
  return { sort: criteria.map(criterion => `${criterion.key},${criterion.order}`) };
}

export function columnSortOrder(criteria: SortCriterion[], key: string): NzTableSortOrder {
  return criteria.find(criterion => criterion.key === key)?.order ?? null;
}

export function columnSortPriority(criteria: SortCriterion[], key: string): number | null {
  if (criteria.length < 2) {
    return null;
  }
  const index = criteria.findIndex(criterion => criterion.key === key);
  return index >= 0 ? index + 1 : null;
}
